export const DESKTOP = '(min-width: 960px)';
export const MOBILE = '(max-width: 959px)';
